module.exports = __webpack_public_path__ + "static/img/taian4.0d0dbb0b.jpg";